module.exports = __webpack_public_path__ + "assets/img/IMG002.3e389d81.png";